// src/pages/Notification/EditNotification.tsx

import {
  AddTwoTone,
  ArrowBackTwoTone,
  DeleteTwoTone,
  EmailTwoTone,
  MoreVertTwoTone,
  NotificationsTwoTone,
  SaveTwoTone,
} from '@mui/icons-material'
import { Avatar, IconButton, MenuItem, Tooltip } from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { FolderPool } from '@/types/domain/folder'
import { SensorPool } from '@/types/domain/sensor'

import { AM, AMItem, KPage, KSelect, KTextField } from '../../components'
import {
  useFolderPool,
  useSensorPool,
  useNotificationApi,
  useNotificationPool,
} from '../../hooks'

type Props = {
  title?: string
}

export const EditNotification = ({
  title = 'Benachrichtigung bearbeiten',
}: Props) => {
  const navigate = useNavigate()
  // if id is provided then edit mode
  // if id is missing then create mode
  const { id } = useParams()

  const fPool: FolderPool = useFolderPool()

  const { remove: removeNotification, save: saveNotification } =
    useNotificationApi()

  const notificationPool = useNotificationPool()

  const sPool: SensorPool = useSensorPool()

  const [actionMenu, setActionMenu] = useState(null)

  const [sensorDeviceID, setSensorDeviceID] = useState('')
  const [folderID, setFolderID] = useState('')
  const [email, setEmail] = useState('')
  const [percent, setPercent] = useState('')

  useEffect(() => {
    const nRecord = notificationPool.find(f => Number(f.id) === Number(id))

    if (!nRecord) return
    const { consumption_type, folder_id, email, percent } = nRecord

    setSensorDeviceID(consumption_type)
    setFolderID(folder_id)
    setEmail(email)
    setPercent(percent)
  }, [notificationPool, id])

  return (
    <>
      {/* action menu */}
      <AM
        anchorEl={actionMenu}
        caption={title}
        open={Boolean(actionMenu)}
        onClose={() => setActionMenu(null)}
        historyUrlTarget={'notifications'}
      >
        <AMItem
          caption={'Zurück'}
          icon={<ArrowBackTwoTone />}
          onClick={() => navigate(-1)}
        />
        <AMItem
          caption={'Neu'}
          disabled={!id}
          icon={<AddTwoTone />}
          onClick={() => navigate('/notifications/new')}
        />

        {!id && (
          <AMItem
            caption={'Speichern'}
            icon={<SaveTwoTone />}
            onClick={() =>
              saveNotification({
                folderID,
                sensorDeviceID,
                percent,
                email,
              })
            }
          />
        )}
        {id && (
          <AMItem
            caption={'Speichern'}
            icon={<SaveTwoTone />}
            /*onClick={() => onSubmit('update')}*/
          />
        )}
        {id && (
          <AMItem
            caption={'Löschen'}
            icon={<DeleteTwoTone />}
            onClick={() => {
              removeNotification(id)
              navigate('/notifications')
            }}
          />
        )}
      </AM>

      <KPage
        action={
          <IconButton onClick={event => setActionMenu(event.currentTarget)}>
            <MoreVertTwoTone />
          </IconButton>
        }
        avatar={
          <Avatar>
            <Tooltip title={`ID: ${id}`}>
              <NotificationsTwoTone />
            </Tooltip>
          </Avatar>
        }
        title={title}
      >
        <KSelect
          label={`Gebäude (ID:${folderID})`}
          onChange={event => setFolderID(event.target.value)}
          value={folderID}
        >
          {fPool.map(f => (
            <MenuItem key={f.id} value={f.id}>
              {f.attributes.name}
            </MenuItem>
          ))}
        </KSelect>

        <KSelect
          label={`Sensor (ID:${sensorDeviceID})`}
          onChange={event => setSensorDeviceID(event.target.value)}
          value={sensorDeviceID}
        >
          {sPool.map(s => (
            <MenuItem key={s.id} value={s.id}>
              {s.attributes.device_id}
              ::
              {s.attributes.sensor_type}
            </MenuItem>
          ))}
        </KSelect>

        <KTextField
          label={'Auslöser'}
          onChange={event => setPercent(event.target.value)}
          type={'number'}
          unit={'% Abweichung'}
          value={percent}
        />

        <KTextField
          icon={<EmailTwoTone />}
          label={'Empfänger'}
          onChange={event => setEmail(event.target.value)}
          type={'email'}
          value={email}
        />
      </KPage>
    </>
  )
}
